module.exports = __webpack_public_path__ + "static/media/sprite.ce124187.svg";